var eqNull = require('./eqNull')
var isNumber = require('./isNumber')
var toNumberString = require('./toNumberString')

function toValueString (obj) {
  if (isNumber(obj)) {
    return toNumberString(obj)
  }
  return '' + (eqNull(obj) ? '' : obj)
}

module.exports = toValueString



//////////////////
// WEBPACK FOOTER
// ./~/.store/xe-utils@3.7.9/~/xe-utils/toValueString.js
// module id = 32
// module chunks = 75